import { IconCirclePlus, IconMail, IconReceipt, IconRefresh, IconToggleLeft, IconToggleRight, IconUserPlus, IconUserStar } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react';
import { Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { getApi } from '../../api/call.api';
import { urlApi } from '../../api/url.api';
import IconButton from '../../components/Buttons/IconButton';
import TableComponent from '../../components/DataTable/TableComponent';
import DropDown from '../../components/DropDown/DropDown';
import SearchComponent from '../../components/Search/SearchComponent';
import Layout from '../../layout/Layout';
import { loadingHide, loadingShow } from '../../loadingUi/loading.controller';
import { dateTimeConverter } from '../../utils/dateTimeConverter';
import ConfirmationModal from '../../components/ConfirmationModal/ConfirmationModal';
import Pagination from '../../components/Pagination/Pagination';
import CreateAgent from './Components/CreateAgent';
import InfluencerListModal from './Components/InfluencerListModal';
import UpdateAgent from './Components/UpdateAgent';
import LinkInfluencerToAgentModal from './Components/LinkInfluencerToAgentModal';
import { accessCheck } from '../../utils/accessCheck';
import { accessKeys } from '../../statics/accessKeys';

const Agents = () => {
    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [searchData, setSearchData] = useState(null);
    const [statusFilter, setStatusFilter] = useState(null)
    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const statusList = [{
        id: null,
        name: "All"
    }, {
        id: 1,
        name: "Active"
    }, {
        id: 2,
        name: "Inactive"
    }]

    async function getAllAgents() {
        loadingShow();
        let statusFilterLocal = statusList?.find(item => item?.name == statusFilter);
        let url = `${urlApi.agentList}?page=${activePage}&limit=${perPage}`;
        if (searchData) {
            url += "&search=" + searchData
        }
        if (statusFilterLocal?.id) {
            url += "&filterByStatus=" + statusFilterLocal?.id
        }
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data?.items,
                totalCount: resp.data?.count
            })
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    useEffect(() => {
        if (accessCheck(accessKeys.viewAgentDetails)) {
            getAllAgents();
        }
    }, [activePage, perPage, statusFilter, searchData]);

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    function onStatusFilterChange(filter) {
        setStatusFilter(filter);
        setActivePage(1);
    }

    function resetAll() {
        setActivePage(1);
        setPerPage(10);
        setSearchData('');
        setStatusFilter(null);
        document.getElementById("agent-table-search").value = ""
    }

    const updateStatus = async (rowData) => {
        let status = rowData.status == 1 ? 2 : 1

        let resp = await getApi(`${urlApi.agentStatusUpdate}${rowData?._id}/${status}`);
        if (resp.responseCode === 200) {
            toast.success(resp.message);
            getAllAgents();
        } else {
            toast.error(resp.message);
        }
    }

    const columns = [
        { name: "Sl. No.", center: "true", width: '60px', selector: (row) => row?._id, cell: (row, index) => (activePage - 1) * perPage + (index + 1) },
        {
            name: "Agent Name", center: "true", selector: (row) => row?.category, grow: 1.8, cell: (row) => (
                <Link to={"/agent-detail/" + row?._id}>
                    <div className="flex items-center gap-2">
                        <img src={row?.profilePic || "https://upload.wikimedia.org/wikipedia/commons/a/ac/Default_pfp.jpg"} className='w-10 aspect-square rounded-full my-1 object-cover' alt="" />
                        <div>
                            <p className="mb-0">{row?.name}</p>
                            <Badge bg={row?.status == 1 ? "success" : "secondary"} >{row?.status == 1 ? "Active" : "InActive"}</Badge>
                        </div>
                    </div>
                </Link>
            )
        }, {
            name: "Mobile", center: "true", selector: (row) => row?.phone, grow: 0.4, cell: (row) => (
                <p className="mb-0">{row?.phone}</p>
            )
        }, {
            name: "Amount", center: "true", selector: (row) => row?.title, grow: 0.4, cell: (row) => (
                <p className="mb-0">{"₹0"}</p>
            )
        }, {
            name: "Created", center: "true", selector: (row) => row?.title, grow: 0.4, cell: (row) => (
                <p className="mb-0"> {dateTimeConverter(row?.createdAt)}</p>
            )
        }, {
            name: "Payouts", center: "true", selector: (row) => row?.link, width: "70px", cell: (row) => (
                <a href={row?.link} target="_blank" rel="noopener noreferrer" className="mb-0"><IconReceipt /></a>
            )
        }, {
            name: "Influencers", center: "true", selector: (row) => row?.title, width: "80px", cell: (row) => (
                <InfluencerListModal agentData={row} buttonComponent={<IconButton icon={<IconUserStar />} />} />
            )
        }, {
            name: "Add Influencer", center: "true", selector: (row) => row?.link, width: "100px", omit: !accessCheck(accessKeys.linkAndUnlinkInfluencer), cell: (row) => (
                <LinkInfluencerToAgentModal buttonComponent={<button title='Add Influencer'> <IconUserPlus size={20} color='#15BC00' /> </button>} agentData={row} />
            )
        }, {
            name: "Email", center: "true", selector: (row) => row?.link, width: "70px", cell: (row) => (
                <button onClick={() => window.location = `mailto:${row?.email}`}> <IconMail size={20} color='#FABC05' /> </button>
            )
        }, {
            name: "Status", center: "true", selector: (row) => row?.link, width: "70px", cell: (row) => (
                <div>
                    {accessCheck(accessKeys.updateAgentStatus) ?
                        <ConfirmationModal buttonComponent={<IconButton icon={row?.status == 1 ? <IconToggleRight color='green' /> : <IconToggleLeft color='red' />} />} confirmationText={`Are you sure want to ${row?.status == 1 ? 'inactive' : 'active'} ${row?.name}`} onConfirm={() => updateStatus(row)} />
                        : <IconButton icon={row?.status == 1 ? <IconToggleRight color='green' /> : <IconToggleLeft color='red' />} />}

                </div>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.link, width: "70px", omit: !accessCheck(accessKeys.createAndEditAgent), cell: (row) => (
                <UpdateAgent callback={() => getAllAgents()} agentData={row} />
            )
        }
    ];

    return (
        <Layout>
            <div className='flex mb-3 gap-3 flex-wrap justify-between items-center'>
                <div>
                    <p className='text-[17px] font-bold mb-0 text-[var(--grey)] px-2'>Agents</p>
                </div>
                {accessCheck(accessKeys.createAndEditAgent) && <CreateAgent callback={() => getAllAgents()} buttonComponent={<IconButton icon={<IconCirclePlus size={20} />} text={"Add Agent"} />} />}
            </div>

            <div className="flex gap-3 flex-wrap mb-3">
                <SearchComponent onClear={() => { document.getElementById("agent-table-search").value = ""; setSearchData('') }} inputValue={searchData}
                    onSearch={() => { setSearchData(document.getElementById("agent-table-search")?.value); setActivePage(1) }} inputId='agent-table-search' placeholder={"Agent Name / Mobile / Email"} />
                <button onClick={() => resetAll()}> <IconRefresh /> </button>
                <div className="ms-auto">
                    <DropDown title={"Status"} list={statusList?.map(item => item?.name)} onSelect={(filter) => onStatusFilterChange(filter)} />
                </div>
            </div>

            <div className="">
                <TableComponent
                    columns={columns}
                    data={tableData.data}
                    totalRows={tableData.totalCount}
                    isHeader={true}
                    isPagination={false}
                    paginationPerPage={perPage}
                    handlePageChange={(e) => handlePageChange(e)}
                    handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

                <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
            </div>
        </Layout>
    )
}

export default Agents